export const getBidTotals = (bidTasks) => {
  const totals = {
    subtotal: 0,
    tax: 0,
    total: 0
  }

  bidTasks.forEach((bidTask) => {
      totals.subtotal += bidTask.subtotal;
  });

  totals.tax = totals.subtotal*0.05;
  totals.total = totals.subtotal + totals.tax;

  return totals;
}

export const getIconName = (key) => {
  switch (key) {
    case "fa-leaf":
      return "leaf";
    case "fa-truck":
      return "truck";
    case "fa-truck-loading":
      return "truck-loading";
    case "fa-truck-pickup":
      return "truck-pickup";
    case "fa-tree":
      return "tree";
    case "fa-house-damage":
      return "house-damage";
    case "fa-people-carry":
      return "people-carry";
    case "fa-seedling":
      return "seedling";
    case "fa-spa":
      return "spa";
    case "fa-trash":
      return "trash";
    case "fa-user-friends":
      return "user-friends";
    default:
  }
}


export const getHostingURL = () => {
  switch (process.env.REACT_APP_FIREBASE) {
    case "development":
      return process.env.REACT_APP_HOSTING_DEV;
    case "production":
      return process.env.REACT_APP_HOSTING_PROD;
    case "test":
      return process.env.REACT_APP_HOSTING_TEST;
    case "ut":
      return process.env.REACT_APP_HOSTING_UT;
    default:
      return process.env.REACT_APP_HOSTING_DEV;
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js